import account from './account'
import addCustomer from './addCustomer'
import carProduct from './carProduct'
import loading from './loading'
import main from './main'
import product from './product'
import searchhHistory from './searchhHistory'
import common from './common'

export default {
  addCustomer,
  account,
  main,
  searchhHistory,
  product,
  loading,
  carProduct,
  common
}
